(function () {
  function wallClock(tz) {
    // Huidige datum/tijd zoals de klok in die tijdzone hem toont
    var s = new Date().toLocaleString('en-US', { timeZone: tz || 'America/New_York' });
    return new Date(s);
  }
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function render(el) {
    var tz = el.getAttribute('data-timezone');
    var now = wallClock(tz);
    var end = new Date(now.getTime());
    end.setDate(now.getDate() + ((7 - now.getDay()) % 7)); // komende zondag (vandaag als het zondag is)
    end.setHours(23, 59, 59, 0);
    var left = Math.max(0, Math.floor((end - now) / 1000));
    var d = Math.floor(left / 86400), h = Math.floor(left % 86400 / 3600), m = Math.floor(left % 3600 / 60), s = left % 60;
    el.querySelector('[data-clock]').textContent = (d > 0 ? d + 'd ' : '') + pad(h) + 'h ' + pad(m) + 'm ' + pad(s) + 's';
    if (el.hasAttribute('data-tiles')) {
      var set = function (sel, v) { var n = el.querySelector(sel); if (n) n.textContent = v; };
      set('[data-days]', d); set('[data-hours]', pad(h)); set('[data-minutes]', pad(m)); set('[data-seconds]', pad(s));
    }
  }
  var timer = null;
  function start() {
    var els = document.querySelectorAll('[data-closing-countdown]');
    if (timer) clearInterval(timer);
    els.forEach(render);
    timer = setInterval(function () { document.querySelectorAll('[data-closing-countdown]').forEach(render); }, 1000);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', start); // thema-editor laadt secties opnieuw
})();
